import { activities } from '.'

export class ActivityCreator {
  constructor(dependencies) {
    this.dependencies = dependencies
  }

  getActivities(mfResult) {
    let createActivity = (activity => {
      if (activities[activity.Type] === undefined) {
        console.warn(`client activity with type ${activity.Type} is not implemented`)
        return undefined
      }
      return new activities[activity.Type](this.dependencies, activity.Parameters)
    }).bind(this)

    if (!mfResult.ClientActivities) {
      return []
    }

    let clientActivities = []

    for (let i = 0; i < mfResult.ClientActivities.length; i++) {
      const activityModel = mfResult.ClientActivities[i]
      let activity = createActivity(activityModel)
      if (activity != undefined) {
        clientActivities.push(activity)
      }
    }
    return clientActivities
  }
}
